.root {
  display: block;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 2lh;
  padding-inline: 2rem;
  padding-bottom: 6lh;
}

.content {
  width: 720px;
  max-width: 100%;
  margin: 0 auto;
}

.header {
  flex: 0;
}

.header > .content {
  padding-top: 1rem;
  display: flex;
  align-items: end;
  justify-content: start;
  gap: 0.875rem;
}

.logo {
  font-size: 2rem;
  flex: 0 0 auto;
}

.nav {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 1.4;
}

.nav-arrow {
  color: var(--accent-dim);
  font-size: 0.75em;
  vertical-align: -0.075em;
  margin-inline: 0.825em 0.625em;
  rotate: 90deg;
}

.nav-arrow:first-child {
  margin-inline-start: 0;
}

.main {
  flex: 0 0 auto;
}

.footer {
  flex: 0 0 auto;
}

@layer {
  .main > .content {
    display: flex;
    flex-direction: column;
    gap: 1.5lh;
  }
}

@media screen and (width < 600px) {
  .root {
    padding-inline: 1.5rem;
  }

  .header > .content {
    padding-top: 1.5rem;
    flex-direction: column;
    align-items: start;
    gap: 0.5rem;
  }

  .nav {
    padding-inline-start: 0.125rem;
    max-width: 100%;
  }

  @layer {
    .main > .content {
      gap: 1lh;
    }
  }
}
